import { CurrentBalanceCompany, DebtTypeEnum } from 'src/types/inputs';

export const TYPE_OF_DEBT_MAP = {
  [DebtTypeEnum.CreditCard]: 'Credit Card',
  [DebtTypeEnum.PersonalLoan]: 'Personal Loan',
  [DebtTypeEnum.AutoLoan]: 'Auto Loan',
  [DebtTypeEnum.StudentLoan]: 'Student Loan',
  [DebtTypeEnum.HomeEquityLoan]: 'Home Equity Loan',
};

export const INSTITUTION_MAP = {
  [CurrentBalanceCompany.AmericanExpress]: 'American Express',
  [CurrentBalanceCompany.WellsFargo]: 'Wells Fargo',
  [CurrentBalanceCompany.Chase]: 'Chase',
  [CurrentBalanceCompany.BankOfAmerica]: 'Bank of America',
  [CurrentBalanceCompany.Citibank]: 'Citi',
  [CurrentBalanceCompany.UsBank]: 'US Bank',
  [CurrentBalanceCompany.Discover]: 'Discover',
  [CurrentBalanceCompany.CapitalOne]: 'Capital One',
  [CurrentBalanceCompany.Other]: 'Somewhere Else',
};
